module.exports = __webpack_public_path__ + "static/media/screen-iglu-cabin-selection.5492c465.png";